import React, { forwardRef } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  scrollbar: {
    height: "calc(100vh - 164px) !important",
    width: "100%",
    backgroundColor: "transparent",
    "&:hover": {
      "& $trackVertical": {
        display: "block"
      }
    }
  },
  trackVertical: {
    display: "none",
    zIndex: 1,
    right: 2,
    bottom: 2,
    top: 2,
    borderRadius: 3
  }
});

const Scrollbar = forwardRef(({ children }, ref) => {
  const classes = useStyles();

  const TrackVertical = ({ style, ...props }) => (
    <div {...props} className={classes.trackVertical} style={{ ...style }} />
  );

  return (
    <Scrollbars
      className={classes.scrollbar}
      ref={ref}
      universal
      renderTrackVertical={TrackVertical}
    >
      {children}
    </Scrollbars>
  );
});

export default Scrollbar;
